// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__BveYf","cell":"ColumnAccessor_cell__2jkIM","firstCellAccent":"ColumnAccessor_firstCellAccent__VrLQ9"};